// extracted by mini-css-extract-plugin
module.exports = {"jobBottomBanner":"JobBottomBanner_jobBottomBanner__1hzfZ","jobDescription":"JobBottomBanner_jobDescription__3xmIf"};